export const FeatureCard = ({ Icon, title, text, badge, n, testId, children }) => (
  <article className="why-card glass glass-light relative h-full rounded-[24px] p-7 sm:p-9 flex flex-col" data-testid={testId}>
    <div className="flex items-start justify-between gap-4">
      <span className="h-12 w-12 rounded-2xl border border-[#1e2024] flex items-center justify-center">
        <Icon className="h-5 w-5 text-cyan" strokeWidth={1.5} style={{ filter: "drop-shadow(0 0 6px rgba(0,229,255,0.6))" }} />
      </span>
      {badge && (
        <span className="rounded-full border border-[#00e5ff]/50 px-2.5 py-1 text-[10px] font-semibold tracking-[0.18em] uppercase text-cyan">{badge}</span>
      )}
      {n && <span className="text-4xl font-extrabold tracking-[-0.05em] text-white/[0.08]">0{n}</span>}
    </div>
    <h3 className="mt-8 font-bold tracking-[-0.025em] text-xl sm:text-2xl">{title}</h3>
    <p className="mt-3 text-sm sm:text-base text-titanium leading-relaxed">{text}</p>
    {children}
  </article>
);
